<template>
  <div class="card border-0">
    <div class="card-body text-center py-4">
      <div class="font-weight-bold mt-1">{{ label }}</div>
      <div class="average-score my-3">{{ average.toFixed(1) }}</div>
      <mobialis-star-bar
        class="mb-1"
        :reviewCount="reviewCount"
        :aggregateRating="average"
        :reviewCountLabel="`${$t('message.DHS.reviews.reviewCount')}`"
        :spacing="2"
        size="large"
      >
      </mobialis-star-bar>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'average-score-card',
  data() {
    return {};
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    average: {
      type: Number,
      required: true,
      default: 999999,
    },
    reviewCount: {
      type: Number,
      required: true,
      default: 9999,
    },
  },
};
</script>

<style scoped lang="scss">
.average-score {
  font-weight: bold;
  font-size: 60px;
  line-height: 60px;
}
@media (min-width: 576px) {
  .card-body {
    min-height: 220px;
  }
}
</style>
